import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { SECTION_MIN_HEIGHT } from "../../utils/constants";
import ProductTypeDialog from "./createPage/ProductTypeDialog";
import AddProduct from "./createPage/AddProduct";
import AddPage from "./createPage/AddPage";
import EditPage from "./product/components/EditPages";
import PagesList from "./product/PagesList";

type Props = {};

const Pages = (props: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeSelectTypeDialog, setActiveSelectTypeDialog] = useState(false);

  const handleCloseSelectTypeDialog = (type?: any) => {
    if (type) {
      if (type === "PRODUCT") {
        navigate("/product/product/create");
      }
      if (type === "COMPONENT") {
        navigate("/product/component/create");
      }
      if (type === "PAGE") {
        navigate("/page/create");
      }
    }
    setActiveSelectTypeDialog(false);
  };

  useEffect(() => {
    if (window.location.pathname?.includes("/product/create")) {
      setActiveSelectTypeDialog(true);
    }
  }, [location.pathname]);
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: SECTION_MIN_HEIGHT,
      }}
    >
      {activeSelectTypeDialog && (
        <ProductTypeDialog
          activeDialog={activeSelectTypeDialog}
          handleDialog={handleCloseSelectTypeDialog}
          type="Page"
        />
      )}

      <Routes>
        <Route path="/" element={<PagesList />} />
        <Route path="/multiple-edit" element={<EditPage />} />
        <Route path="/create" element={<AddPage />} />
        <Route path="/edit/:id" element={<AddPage />} />
      </Routes>
    </Box>
  );
};

export default Pages;
